export default {
	/** Whether to preserve the original functional color declaration. */
	preserve: false,
};
